import React from 'react';
import { Calendar } from 'primereact/calendar';
import { useTranslation } from 'react-i18next';

import './date-template.scss';

interface DateFilterTemplateProps {
  options: {
    value: Date | null;
    filterApplyCallback: (value: Date | null) => void;
  };
}

const DateFilterTemplate: React.FC<DateFilterTemplateProps> = ({ options }) => {
  const { t } = useTranslation();

  return (
    <Calendar
      value={options.value}
      onChange={(e) => options.filterApplyCallback(e.value as Date | null)}
      dateFormat="yy-mm-dd"
      placeholder={t('selectDate')}
      className="custom-calendar"
      showButtonBar={true}
      readOnlyInput={true}
      inline={true}
    />
  );
};

export default DateFilterTemplate;
